import {
    AdminPanelSettings,
    Diversity3,
    Payment,
    SmartToy,
    Sports,
    SportsEsports,
} from "@mui/icons-material";
import { ROLE_CONFIG, USER_TYPE } from "../object-actions/types/types";

export type RoleIconSize = "small" | "large";

const ICON_COMPONENTS = {
    Sports,
    Diversity3,
    SportsEsports,
    AdminPanelSettings,
    SmartToy,
    Payment,
} as const;

const THEME_COLOR: Record<(typeof ROLE_CONFIG)[USER_TYPE]["color"], string> = {
    primary: "primary.main",
    secondary: "secondary.main",
    success: "success.main",
    error: "error.main",
    info: "info.main",
    warning: "warning.main",
};

/** MUI icon for a user role. Colors follow ROLE_CONFIG when size is large. */
export function getRoleIcon(role: USER_TYPE, size: RoleIconSize = "small") {
    const config = ROLE_CONFIG[role];
    const Icon = ICON_COMPONENTS[config.icon as keyof typeof ICON_COMPONENTS];
    if (!Icon) return null;

    if (size === "small") {
        return <Icon fontSize="small" />;
    }

    return <Icon sx={{ fontSize: 48, color: THEME_COLOR[config.color] }} />;
}
